export default __webpack_public_path__ + "static/media/Mining_bg.98206831.jpg";